// extracted by mini-css-extract-plugin
export var productImage = "_pr-0";